<template>
  <div class="select-outer">
    <div class="title-outer">
      <span>VIP预定</span>
    </div>
    <div class="form-outer">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <div style="font-weight: 600; margin-bottom: 10px">业主信息</div>
        <el-form-item label="员工姓名" prop="staffName">
          <el-input v-model="ruleForm.staffName"></el-input>
        </el-form-item>
        <el-form-item label="工号" prop="jobNumber">
          <el-input v-model="ruleForm.jobNumber"></el-input>
        </el-form-item>
        <el-form-item label="预订人电话" prop="subscriberNumber">
          <el-input v-model="ruleForm.subscriberNumber"></el-input>
        </el-form-item>
        <el-form-item label="一级分公司名" prop="stairCompanyName">
          <el-input v-model="ruleForm.stairCompanyName"></el-input>
        </el-form-item>
        <el-form-item label="二级分公司名" prop="secondCompanyDepartment">
          <el-input v-model="ruleForm.secondCompanyDepartment"></el-input>
        </el-form-item>

        <!-- 下边的表单内容 -->
        <div
          class="tabs"
          style="display: flex; justify-content: flex-end; margin-bottom: 2rem"
        >
          <el-radio-group
            v-model="labelPosition"
            size="small"
            @change="changeTab"
          >
            <el-radio-button label="0">房预定</el-radio-button>
            <el-radio-button label="1">餐预定</el-radio-button>
          </el-radio-group>
        </div>
        <!-- 房预定 -->
        <template v-if="labelPosition == '0'">
          <el-form-item label="入住人姓名" prop="roomDetail.guestName">
            <el-input v-model="ruleForm.roomDetail.guestName"></el-input>
          </el-form-item>
          <el-form-item label="到店日期" prop="roomDetail.dataOfArrival">
            <el-date-picker
              v-model="ruleForm.roomDetail.dataOfArrival"
              type="date"
              placeholder="选择到店日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="离店日期" prop="roomDetail.checkOutDate">
            <el-date-picker
              v-model="ruleForm.roomDetail.checkOutDate"
              type="date"
              style="width: 100%"
              placeholder="选择离店日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="价格类型：" prop="roomDetail.priceType">
            <el-select
              clearable
              v-model="ruleForm.roomDetail.priceType"
              placeholder="请选择价格类型"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in priceTypeList"
                :key="item.id"
                :label="item.dictionaryName"
                :value="item.id"
                >{{ item.dictionaryName }}</el-option
              >
            </el-select>
          </el-form-item>
          <el-form-item label="房型：" prop="roomDetail.priceType">
            <el-select
              clearable
              v-model="ruleForm.roomDetail.roomType"
              placeholder="请选择房型"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in roomTypeList"
                :key="item.id"
                :label="item.dictionaryName"
                :value="item.id"
                >{{ item.dictionaryName }}</el-option
              >
            </el-select>
          </el-form-item>
        </template>
        <!-- 餐预定 -->
        <template v-else>
          <el-form-item label="包房、大厅" prop="mealDetail.privateRoomHall">
            <el-input v-model="ruleForm.mealDetail.privateRoomHall"></el-input>
          </el-form-item>
          <el-form-item label="用餐人数：" prop="mealDetail.numberOfDiners">
            <el-input
              v-model="ruleForm.mealDetail.numberOfDiners"
              placeholder="用餐人数"
            ></el-input>
          </el-form-item>
          <el-form-item label="用餐时间：" prop="mealDetail.diningStandard">
            <el-date-picker
              type="date"
              placeholder="请选择用餐时间"
              v-model="ruleForm.mealDetail.diningStandard"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="预定来源："
            prop="mealDetail.intendedSource"
            style="width: 100%"
          >
            <el-select
              v-model="ruleForm.mealDetail.intendedSource"
              placeholder="请选择预定来源"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in orderFromList"
                :key="item.id"
                :label="item.dictionaryName"
                :value="item.id"
                >{{ item.dictionaryName }}</el-option
              >
            </el-select>
          </el-form-item>
          <el-form-item
            label="餐段："
            prop="mealDetail.diningSegment"
            style="width: 100%"
          >
            <el-select
              v-model="ruleForm.mealDetail.diningSegment"
              placeholder="请选择餐段"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in mealTimeList"
                :key="item.id"
                :label="item.dictionaryName"
                :value="item.id"
                >{{ item.dictionaryName }}</el-option
              >
            </el-select>
          </el-form-item>
          <el-form-item label="其他备注：" style="width: 100%">
            <el-input
              type="textarea"
              v-model="ruleForm.mealDetail.remark"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </template>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >立即创建</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getDictGroupByTypes, saveRoom, saveMeal } from "@/api/process";
export default {
  data() {
    return {
      ruleForm: {
        staffName: "", //员工姓名
        jobNumber: "", //工号
        subscriberNumber: "", //预订人电话
        stairCompanyName: "", //一级分公司名
        secondCompanyDepartment: "", //二级分公司
        roomDetail: {
          guestName: "", //入住人姓名
          dataOfArrival: "", //到店日期
          checkOutDate: "", //离店日期
          priceType: "", //价格类型
        },

        // },
        mealDetail: {
          privateRoomHall: "", //包房、大厅
          numberOfDiners: "", //用餐人数
          diningStandard: "", //用餐时间
          intendedSource: "", //预定来源
          diningSegment: "", //餐段
          remark: "", //其他
        },

        // }
      },

      priceTypeList: [],
      orderFromList: [],
      roomTypeList: [],
      mealTimeList: [],
      labelPosition: "0",
      rules: {
        staffName: [
          { required: true, message: "请输入员工姓名", trigger: "blur" },
        ],

        jobNumber: [
          { required: true, message: "请输入员工号", trigger: "blur" },
        ],
        subscriberNumber: [
          { required: true, message: "请输入预订人电话", trigger: "blur" },
        ],
        stairCompanyName: [
          { required: true, message: "请输入一级分公司名", trigger: "blur" },
        ],
        secondCompanyDepartment: [
          { required: true, message: "请输入二级分公司名", trigger: "blur" },
        ],

        "roomDetail.guestName": [
          { required: true, message: "请输入入住人姓名", trigger: "blur" },
        ],
        "roomDetail.dataOfArrival": [
          {
            // type: "date",
            required: true,
            message: "请选择到店日期",
            trigger: "change",
          },
        ],
        "roomDetail.checkOutDate": [
          {
            // type: "date",
            required: true,
            message: "请选择离店日期",
            trigger: "change",
          },
        ],
        "roomDetail.priceType": [
          { required: true, message: "请选择价格类型", trigger: "change" },
        ],
        "roomDetail.roomReservationNumber": [
          { required: true, message: "请输入房间预定号", trigger: "blur" },
        ],
        mealDetail: {
          dinnerCanteen: [
            { required: true, message: "请选择用餐餐厅", trigger: "change" },
          ],
          privateRoomHall: [
            { required: true, message: "请输入包房、大厅", trigger: "blur" },
          ],
          numberOfDiners: [
            { required: true, message: "请输入用餐人数", trigger: "blur" },
          ],
          diningStandard: [
            { required: true, message: "请选择用餐时间", trigger: "change" },
          ],
          intendedSource: [
            { required: true, message: "请选择预订来源", trigger: "change" },
          ],
          diningSegment: [
            { required: true, message: "请选择餐段", trigger: "change" },
          ],
          remark: [
            { required: true, message: "请输入其他备注", trigger: "blur" },
          ],
        },
      },
    };
  },
  methods: {
    changeTab() {
      //  this.resetForm("ruleForm");
      this.clearValidate("ruleForm");

      this.ruleForm.roomDetail = {
        guestName: "", //入住人姓名
        dataOfArrival: "", //到店日期
        checkOutDate: "", //离店日期
        priceType: "", //价格类型
      };
      this.ruleForm.mealDetail = {
        privateRoomHall: "", //包房、大厅
        numberOfDiners: "", //用餐人数
        diningStandard: "", //用餐时间
        intendedSource: "", //预定来源
        diningSegment: "", //餐段
        remark: "", //其他
      };
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.labelPosition == "0") {
            //房预定
            saveRoom({
              ...this.ruleForm,
              source: 1,
              ticket: localStorage.getItem("ticketUrl"),
            }).then((res) => {
              console.log(res.data);
              if (res.data.code == 200) {
                this.$message.success("操作成功");
              } else {
                //  alert(res.data.msg + "```" + res.data.code);
                this.$message.error(res.data.msg);
              }
            });
          } else {
            //参预定
            saveMeal({
              ...this.ruleForm,
              source: 1,
              ticket: localStorage.getItem("ticketUrl"),
            }).then((res) => {
              if (res.data.code == 200) {
                this.$message.success("操作成功");
              } else {
                this.$message.error(res.data.msg);
              }
            });
          }
        } else {
          this.$message.error("操作失败");
          return false;
        }
      });
    },
    getSelectLists(type) {
      // 1：房价类型配置；2：用餐餐厅配置；3：预定来源配置；4：支付类型配置、5：餐段、6：确认房型、7：折扣信息、8：房核销付款方式、9：餐核销付款方式
      // if(type==6)   1房价类型配置,6房型he确认房型    can: 2：用餐餐厅配置；3：预定来源配置；5：餐段

      this.priceTypeList = [];
      this.roomTypeList = [];
      this.orderFromList = [];
      this.mealTimeList = [];
      getDictGroupByTypes({
        types: type,
        ticket: localStorage.getItem("ticketUrl"),
      }).then((res) => {
        let dataObj = res.data;
        if (dataObj.code == "200") {
          //JSON.stringify(dataList.data)
          dataObj.data.map((ele) => {
            // 房 1房价类型配置,6房型he确认房型
            if (ele.type == 1) {
              this.priceTypeList = ele.list;
            }
            if (ele.type == 6) {
              this.roomTypeList = ele.list;
            }

            // 餐 2：用餐餐厅配置；3：预定来源配置；5：餐段
            // if(ele.type==2) {
            //   this.restType = ele.list
            // }
            if (ele.type == 3) {
              this.orderFromList = ele.list;
            }
            if (ele.type == 5) {
              this.mealTimeList = ele.list;
            }
          });
        } else {
          this.$message.error(dataObj.msg);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    clearValidate(formName) {
      this.$refs[formName].clearValidate();
    },
  },
  mounted() {
    // localStorage.setItem("ticketUrl", ticketUrl);
    // alert("``" + localStorage.getItem("ticketUrl"));
    this.getSelectLists("1,6,3,5");

    //获取字典
  },
};
</script>
<style lang="less" scoped lang="less">
.select-outer {
  padding: 1rem;
  .title-outer {
    text-align: center;
    margin: 1.5rem auto;
    font-size: 1.3rem;
    font-weight: 600;
  }
}
</style>
